const utils = (function () {
    'use strict';

    if (!$) {
        console.log('jQuery Not exits');
    } else {
        console.log('POPSale utils is running')
    }

    function missElms(elementName) {
        console.log('Please ensure your document has' + elementName + ' element!');
    }

    function snackText(message) {
        const snackBar = $('.mdc-snackbar')[0].MDCSnackbar;
        const snackBarText = $('.mdc-snackbar__label');

        if (typeof snackBar === 'undefined' || typeof snackBarText === 'undefined') {
            missElms('.mdc-snackbar');
            return
        }
        snackBarText.text(message);
        snackBar.open();
    }

    function isLoading(isLoading) {
        const loadingIndicator = $('.mdc-linear-progress')[0].MDCLinearProgress;

        if (typeof loadingIndicator === 'undefined') {
            missElms('.mdc-linear-progress');
            return
        }

        if (isLoading) {
            loadingIndicator.open();
        } else {
            loadingIndicator.close();
        }

    }

    /**
     * Confirmation dialog
     *
     * @param {string} message
     * @param {function} confirm
     * @param {function|null} cancel
     */
    let confirm = function confirm(message, confirm, cancel) {
        let dialog = $('#res-edit-dialog');
        dialog.show();

        $('#res-edit-dialog .dialog__container--description').html(message);

        $('#res-edit-dialog .submit').on('click', function () {
            confirm(dialog);
        });

        $('#res-edit-dialog .cancel').on('click', function () {
            dialog.hide();
            if (cancel) {
                cancel(dialog);
            }
        })
    };

    /**
     * Send form request to server
     *
     * @param {string|location} url
     * @param {string} method
     * @param {FormData} data
     * @param {function} handler
     * @param {function|null} errorHandler
     * @returns {*|jQuery|{getAllResponseHeaders, abort, setRequestHeader, readyState, getResponseHeader, overrideMimeType, statusCode}}
     */
    let formRequest = function formRequest(url, method, data, handler, errorHandler = null) {
        return $.ajax({
            url: url,
            data: data,
            method: method,
            contentType: false,
            processData: false,
            cache: false,
            beforeSend: function() {
                popsale.loading(true);
            },
            success: handler,
            error: errorHandler || function(error) {
                if (error.hasOwnProperty('responseJSON')) {
                    popsale.snackText(error.responseJSON.error || error.responseJSON.errors || '不明錯誤');
                }
            },
            complete: function () {
                popsale.loading(false);
            },
        });
    };

    let toChineseDiscount = function(value) {
        let discount = Math.round( (100 - value) * 100) / 100;

        if (discount < 10) {
            return '0' + discount;
        }

        if (discount % 10) {
            return discount
        }

        return discount / 10
    };

    return {
        snackText: function (message) {
            snackText(message);
        },
        loading: function (boolean) {
            isLoading(boolean);
        },
        toChineseDiscount: toChineseDiscount,
        confirm: confirm,
        formRequest: formRequest,
    };
});

const popsale = new utils();

export default popsale;